import * as THREE from 'three';

export function createScene() {
  const scene = new THREE.Scene();

  // Very dark background to simulate a dark room with CRT glow
  scene.background = new THREE.Color(0x0a0a0f);

  // Darker fog for CRT atmosphere
  scene.fog = new THREE.Fog(0x0a0a0f, 10, 35);

  return scene;
}
